import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClientSummary } from '../../2_domain/client/client';
import IClientRepository from '../../2_domain/client/iClientRepository';
import Get from '../../lib/di/get';
import promiseResolver from '../../lib/util/promiseResolver';

const emptyPagination: Pagination = {
  isAscending: false,
  pageNumber: 0,
  pageSize: 20,
};

const emptyPageResult: Page = {
  totalElements: 0,
  pageNumber: 0,
};

let timer: NodeJS.Timeout | undefined;
let searchText: string;
const useClientListPageController = () => {
  const clientRepo = Get.find<IClientRepository>('IClientRepository');
  const navigate = useNavigate();

  const [pagination, setPagination] = useState<Pagination>(emptyPagination);
  const [page, setPage] = useState<Page>(emptyPageResult);
  const [clients, setClients] = useState<ClientSummary[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const setPageNumber = (newPageNumber: number) => {
    setPagination((prev) => {
      return { ...prev, pageNumber: newPageNumber };
    });
  };
  const setPageSize = (newPageSize: number) => {
    setPagination((prev) => {
      return { ...prev, pageSize: newPageSize };
    });
  };
  const setFilter = (newFilter: SortFilter) => {
    setPagination((prev) => {
      return { ...prev, isAscending: newFilter === 'Oldest' };
    });
  };
  const onSearchTextChangeHandler = (newSearchText: string) => {
    setIsLoading(true);
    searchText = newSearchText;
    clearTimeout(timer);
    timer = setTimeout(() => loadData(), 500);
  };

  const navigateToAddPatient = async () => {
    navigate('../add');
  };

  const loadData = async () => {
    await promiseResolver<PageResult<ClientSummary>>({
      promise: clientRepo.getClients({ searchText, pagination }),
      successCallback: (data) => {
        setPage(data.page);
        setClients(data.list);
      },
      isLoadingCallback: setIsLoading,
    });
  };

  const navigateToPatientId = (id: number) => () => {
    navigate(`../${id}`);
  };

  useEffect(() => {
    loadData();
    return () => {
      clearTimeout(timer);
      searchText = '';
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination]);

  return {
    clients,
    pagination,
    setPageNumber,
    setPageSize,
    setFilter,
    onSearchTextChangeHandler,
    navigateToAddPatient,
    isLoading,
    page,
    navigateToPatientId,
  };
};

export default useClientListPageController;
